import { Injectable } from '@angular/core';
import { Column } from '@miq/catalog';

/**
 * Default behavior for disabling a miq-control based on a generic component that contains a `isDisabled` boolean value
 * @param column
 * @param isDisabled
 * @returns
 */
const CREATE_MODE_SET_DISABLED = (column: Column, isDisabled: boolean): Column => {
  if (isDisabled != null) {
    column = { ...column, isDisabled };
  }
  return column;
};

/**
 * Abstract template
 */
@Injectable({ providedIn: 'root', useValue: { setDisabled: CREATE_MODE_SET_DISABLED } })
export abstract class DisabledFormStateService {
  abstract setDisabled(_column: Column, _isDisabled: boolean): Column;
}

/**
 * Useful for forms created for catalogs in create mode
 */
@Injectable()
export class CreateDisabledFormStateService extends DisabledFormStateService {
  setDisabled(column: Column, isDisabled: boolean): Column {
    return CREATE_MODE_SET_DISABLED(column, isDisabled);
  }
}

/**
 * Useful for forms created for catalogs in update (edp graphql) mode, it disables the column if column
 * column is configured to do so, or if there is no EDP update configuration (graphql method and fields)
 */
@Injectable()
export class RecordDisabledFormStateService extends DisabledFormStateService {
  setDisabled(column: Column, isDisabled: boolean): Column {
    const { parent } = column;
    if (isDisabled != null) {
      column = { ...column, isDisabled };
    } else if (!parent.update) {
      column = { ...column, isDisabled: true };
    }
    return column;
  }
}
